import { render } from "./Devices.vue?vue&type=template&id=b3661d58&scoped=true"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b3661d58"

export default script